import { compact, isArray, isEmpty, reduce, keys, invert } from 'underscore';
import { SmartActionButtonTypes } from '@bingads-webui-campaign-react/smart-component-action-button';
import { WEBSITE_SOURCE_DATA_KEY_MAPPING } from '@bingads-webui-campaign-react/smart-component-util';

export const proxyReadContactComponentConfig = (componentConfig) => {
  const {
    showEmail = true,
    showPhone = true,
    showLocation = true,
    showHours = true,
    showMap, // don't provide default value, undefined is also a status
  } = componentConfig;

  return {
    showEmail,
    showPhone,
    showLocation,
    showHours,
    showMap,
  };
};

export const toggleValueToActionButtonTypeMapping = {
  showEmail: SmartActionButtonTypes.SendMail.name,
  showPhone: SmartActionButtonTypes.CallNow.name,
  showLocation: SmartActionButtonTypes.GetDirections.name,
};

export const getActionTypesForContactComponent = (componentConfig) => {
  const {
    showEmail,
    showPhone,
    showLocation,
  } = proxyReadContactComponentConfig(componentConfig);
  const actionTypes = compact([
    showEmail && toggleValueToActionButtonTypeMapping.showEmail,
    showPhone && toggleValueToActionButtonTypeMapping.showPhone,
    showLocation && toggleValueToActionButtonTypeMapping.showLocation,
  ]);

  return actionTypes;
};

const MAPPING_KEY_TO_MT = {
  latitude: 'Latitude',
  longitude: 'Longitude',
  isFallbackLoc: 'IsFallbackLoc',
};

const MAPPING_MT_TO_KEY = invert(MAPPING_KEY_TO_MT);

/**
 * Make the key name as upper case or lower case
 * MT variable name is different from UI side, MT need variable name to be started with
 * capital while UI side needs to be lower case.
 * @param {Object} geoLocationInfo GeolocationInfo
 * @param {Boolean} needUpperKeyName To upper case or lower case
 * @returns {Object} A formatted geoLocationInfo
 */
export const formatGeoLocation = (geoLocationInfo, needUpperKeyName) => {
  if (isEmpty(geoLocationInfo)) {
    return geoLocationInfo;
  }

  if (needUpperKeyName) {
    return reduce(keys(geoLocationInfo), (memo, cur) => {
      const newKeyName = MAPPING_KEY_TO_MT[cur];

      return newKeyName ? { ...memo, [newKeyName]: geoLocationInfo[cur] } : memo;
    }, {});
  }

  return reduce(keys(geoLocationInfo), (memo, cur) => {
    const newKeyName = MAPPING_MT_TO_KEY[cur];

    return newKeyName ? { ...memo, [newKeyName]: geoLocationInfo[cur] } : memo;
  }, {});
};

export const getGeolocationInfo = (siteConfig = {}) => {
  let geoLocationInfo = null;
  const { websiteSourceData = {} } = siteConfig;
  const locations = websiteSourceData[WEBSITE_SOURCE_DATA_KEY_MAPPING.Locations];

  if (isArray(locations) && !isEmpty(locations[0])) {
    [geoLocationInfo] = locations;
  }

  return formatGeoLocation(geoLocationInfo, false);
};
